import { WHITESPACE_REGEX } from '@monoimin/constants';

import { transliterateRuString } from '../formatters';

import { normalizeTitle } from './normalizeTitle';

import type { Locales } from '@monoimin/sb-types';

const splitByWhitespace = (string: string) => {
  return string
    .split(WHITESPACE_REGEX)
    .filter((item) => item.trim().length > 0);
};

export const defineTitleId = (title: string | undefined, locale: Locales) => {
  if (title) {
    const normalizedTitle = normalizeTitle(title);

    const stringForId =
      locale === 'ru'
        ? transliterateRuString(normalizedTitle)
        : normalizedTitle;

    return splitByWhitespace(stringForId).join('_').toLowerCase();
  }

  return '';
};

export default defineTitleId;
